import React, { FC } from 'react';
import styles from './styles.module.scss';

export const TextInput: FC<{
    label: string;
    placeHolder: string;
    onChange: (value: string) => void;
}> = ({ label, placeHolder, onChange }) => {
    return (
        <div className={styles.formGroup}>
            <label>{label}</label>
            <input
                onChange={(e) => onChange(e.currentTarget.value)}
                type="text"
                placeholder={placeHolder}
            />
        </div>
    );
};
